 
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { userActions } from '../../actions/user.actions';
import axiosInstance from '../../helpers/axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import user1 from '../../assets/images/user.png';
import {
  Card,
  Input
} from 'reactstrap';
import submitActivity from '../../assets/images/submitActivity.png';
import send from '../../assets/images/send.png';
import './Loanindex.css';
import { useCurrentUser } from '../../hooks/useCurrentUser';

export default function LoanActivity({activityData}) {
  const location=useLocation();
  const dispatch=useDispatch()
  const decode = useCurrentUser();
  const user = null;
  const getActivityState=useSelector((state)=>state?.ACTIVITY?.activityData)
  const { legacyLoanId, loanid, activityAppId, repaymentsUserId } = useSelector(state => state.appContext);
  const [activityDetails,setActivityDetails]=useState(activityData)
  const [activityDetailsApp,setActivityDetailsApp]=useState(null)
  //
  const urlAddActivity=`/loan-repayment/activity`
  const getActivityUrl=`/loan-repayment/activity?legacyLoanId=${legacyLoanId}`
  const getActivityUrlApp=`/audit?applicationId=${activityAppId}`
  

  // useEffect(() => {
    

  // }, [getActivityState])




  useEffect(() => {
     const ref = document.getElementById('chatcontent');
     setTimeout(()=> {
       ref.scrollTop = ref.scrollHeight;
     }, 100);
     if (Array.isArray(getActivityState?.res?.data?.data) && getActivityState.res.data.data.length > 0){
       setActivityDetails(getActivityState?.res?.data?.data)
     }
     else if (!getActivityState?.loading && !getActivityState?.res?.data?.data) {
             dispatch(userActions.getLoanActivity(getActivityUrl,user))
           }
    
    setTimeout(()=> {
      ref.scrollTop = ref.scrollHeight;
    }, 100);
   if (activityAppId) {
     axiosInstance.get(getActivityUrlApp, {
               headers: {
               },
             }).then((res)=>{
               setTimeout(()=> {
                 ref.scrollTop = ref.scrollHeight;
               }, 100);
               setActivityDetailsApp(res?.data?.data)
               })
   }
  
  },[getActivityState, activityAppId, legacyLoanId])
  

  const [activityDescrition,setActivityDescription]=useState(null)


  async function handleSubmitActivity(){
    setActivityDescription(null)
    document.getElementById('descriptionBox').value=null
    const now = new Date();
const dateTime = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now
  .getDate()
  .toString()
  .padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now
  .getMinutes()
  .toString()
  .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
    const activityBody={
        "legacyLoanId" : legacyLoanId,
        "loanId" : loanid,
        "userId": repaymentsUserId,
        "notes": activityDescrition,
        "date": dateTime,
        "amount":''
    }
     await dispatch(userActions.submitLoanActivity(urlAddActivity,activityBody,user))

     
  }
  const [isOpen,setIsOpen]=useState(true)
   
  return (
     <>
  
   <Card className="card" style={{width:"100%",height:'100%'}} >
          
          
            <div className="chatContainer">
            
              <div id="chatcontent" style={{overflowY: 'scroll',height:'85%'}}>
                
              {
            
            activityDetailsApp?.map((item)=>{
  
                  if(decode?.email!==item.doneBy)
                  {
  
                    return(
                      <div className="receiver" style={{marginLeft:'1em',

                        ...((item.doneBy === 'system' ) && { backgroundColor: '#F0E7FD',border: '2px solid #D3C4EC' }) 
                      }}>
              
                  <p style={{marginTop:'-4em', display: 'flex',alignItems: 'center',flexWrap: 'nowrap', whiteSpace: 'nowrap'  }} ><img src={user1} style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.createdAt} </span></p>
                  <p><span style={{fontWeight:'bold'}}>Status :</span> {item.status}</p>
                    {item.notes}
                  </div>
                    )
                  
                  }
                  else{
                    
                    return(
  
                    <div className="sender" >
                      <p style={{marginTop:'-4em',right:'4em'}} ><img src={user1} style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.createdAt} </span></p>
                    <p><span style={{fontWeight:'bold'}}>Status : </span> {item.status}</p>
                     {item.notes}
                   </div>
                    )
                     
                    }
              })
              
            }
           {
            
            activityDetails?.filter(item => 
              !item.notes?.includes("IVR Notification sent to user") && 
              !item.notes?.includes("Call Date:")
            )?.map((item)=>{

                if(decode?.email!==item.doneBy)
                {

                  return(
                    <div className="receiver" 
                    style={{marginLeft:'1em',

                      ...((item.doneBy === 'system' || item.doneBy === null) && { backgroundColor: '#F0E7FD',border: '2px solid #D3C4EC' }) 
                    }} 
                    >
            
                <p style={{marginTop:'-4em'  }} ><img src={user1} style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.created_at} </span></p>
                {/* <p><span style={{fontWeight:'bold'}}>Status :</span> {item.status}</p> */}
                {item.doneBy === 'system' ? (
                            <>
                              {/* <p><span style={{fontWeight:'bold'}}>CreatedAt:</span> {item.created_at}</p> */}
                              <p><span style={{fontWeight:'bold'}}>Amount:</span> {item.amount}</p>
                              <p><span style={{fontWeight:'bold'}}>Date:</span> {item.date}</p>
                              <p><span style={{fontWeight:'bold'}}>Notes:</span> {item.notes}</p>
                            </>
                          ) :   item.doneBy === 'end-user' ? (
                            <>
                             <p><span style={{fontWeight:'bold'}}>Amount:</span> {item.amount}</p>
                              <p><span style={{fontWeight:'bold'}}>Date:</span> {item.date}</p>
                              <p><span style={{fontWeight:'bold'}}>Notes:</span> {item.notes}</p>
                            </>
                          ) :
                          
                          (
                            <>
                           { item.amount !== null && item.amount !== undefined && item.amount !== '' ? <p><span style={{fontWeight:'bold'}}>Amount:</span> {item.amount}</p> : " "}
                            <p><span style={{fontWeight:'bold'}}>Notes:</span> {item.notes}</p>
                            </>
                          )}
                </div>
                  )
                
                }
                else{
                  
                  return(

                  <div className="sender">
                    <p style={{marginTop:'-4em'}} ><img src={user1} style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.created_at} </span></p>
                  {/* <p><span style={{fontWeight:'bold'}}>Status : </span> {item.status}</p> */}
                  <p><span style={{fontWeight:'bold'}}>notes : </span> {item.notes}</p>
                   
                 </div>
                  )
                   
                  }
            })
            
          }
                   
                   </div> 
          {(decode.role === "admin" || decode.role === "collection" || decode.role === "finance" || decode.role==="crm")&&( <div style={{borderRadius:'12px' ,marginTop:'1em',border:'1px solid #E7BABC',backgroundColor:'#FFEDEE',padding:'1em',display:'flex',justifyContent: 'space-between',}}>
            <Input id="descriptionBox" style={{width:'83%'}} onChange={(e)=>setActivityDescription(e.target.value)} type='text' placeholder="Log Activity Here"/>
            <div onClick={()=>handleSubmitActivity()} style={{cursor:'pointer',marginLeft:'10px'}} >
              <img style={{position:'absolute',padding:'0.8em'}} src={send}/>
              <img src={submitActivity}/>
            </div>
          </div>) }
    </div>
        
  </Card>
  </>
    
  )
}
